import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { CreateQAQuestion, QAQuestionsList } from "@/builders/types/qa";
import { qa_answers } from "./answers.ts";

const post = function (data: CreateQAQuestion) {
  return api.post("qa", data);
};

const get = function (id: number) {
  return api.get(`qa/${id}`).then(({ data }) => data);
};

const list = function (
  params?: FilterParams<{
    course: number | undefined;
  }>
) {
  return api.get<QAQuestionsList>("qa", { params }).then(({ data }) => data);
};
const del = function (id: number) {
  return api.delete(`qa/${id}`).then(({ data }) => data);
};

const put = function attempt(variables: {
  id: number;
  data: {
    course_id: number;
    question: string;
  };
}) {
  const { id, data } = variables;
  return api
    .put(`qa/${id}`, data)
    .then(({ data }) => data)
    .then(({ data }) => data);
};
export const qa = {
  post,
  get,
  list,
  del,
  put,
  qa_answers,
};

